import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tooltipList',
  standalone: true
})
export class TooltipListPipe implements PipeTransform {

transform(lines: any[], displayProp: string = null): string {

    let list: string = '';

    lines.forEach(line => {
      list += (displayProp !== null) ? line[displayProp] + '\n' : line + '\n'; 
    });

    return list;
  }

}
